import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getServicesByCategory } from '@/lib/content';

export default function CategoryQuickNav() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
            <i className="ri-apps-2-line"></i>
          </span>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">分类快捷入口</h2>
            <p className="text-sm text-foreground-500 mt-1">按需进入对应分类，快速浏览该领域全部服务</p>
          </div>
        </div>
        <Link to="/categories" className="shrink-0 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer">
          全部分类
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex items-start gap-3 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 text-2xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={cat.icon}></i>
            </span>
            <div className="min-w-0">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{cat.description}</p>
              <span className="inline-block mt-2 text-xs text-secondary-600">
                {getServicesByCategory(cat.id).length} 项服务
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}